import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// Initializes any [data-swiper] element found on the page.
// No-op if the page has none, so this is safe to call from any page-specific entry.
export function initSwipers() {
	document.querySelectorAll('[data-swiper]').forEach((el) => {
		const options = el.dataset.swiper ? JSON.parse(el.dataset.swiper) : {};
		new Swiper(el, {
			modules: [Navigation, Pagination, Autoplay, A11y],
			...options,
		});
	});
}
